module.exports = __webpack_public_path__ + "static/img/celoscope-detail-11.fb6e139.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-11.jpg
// module id = hY0d
// module chunks = 52